module.exports = __webpack_public_path__ + "img/catD.38a0096d.svg";